import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  code?: number;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

/** 后端未登录业务码（对应 ErrorCode.NOT_LOGIN_ERROR） */
const NOT_LOGIN_CODE = 40100;

/** 是否已在登录页：exportStatic 会生成 /user/login 目录，nginx 会把 /user/login 301 到 /user/login/ */
const isLoginPath = (pathname: string) =>
  pathname === '/user/login' || pathname.replace(/\/+$/, '') === '/user/login';

/** 统一未登录处理：清除登录态并跳转登录页 */
const handleNotLogin = () => {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  if (!isLoginPath(window.location.pathname)) {
    message.error('登录已过期，请重新登录');
    const { search, pathname } = window.location;
    const redirect = encodeURIComponent(pathname + search);
    window.location.href = `/user/login?redirect=${redirect}`;
  }
};

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig: RequestConfig = {
  // baseURL 优先用环境变量，否则走 nginx 同源代理（和 agent/H5 一致）
  baseURL: (window as any).API_BASE_URL || '/api',
  withCredentials: true,

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 拦截请求配置，进行个性化处理。
      // const url = config?.url?.concat('?token=123');

      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");

      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }

      return { ...config };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      // 统一未登录处理：清除登录态并跳转登录页
      if (data?.code === NOT_LOGIN_CODE) {
        handleNotLogin();
        return response;
      }

      if (data?.success === false) {
        message.error('请求失败！');
      }
      return response;
    },
  ],

  // 错误处理器：兜底处理 HTTP 层错误（如 401/500 等非 200 状态）
  errorConfig: {
    errorHandler: (error: any) => {
      const { response } = error || {};
      if (response && response.status === 401) {
        handleNotLogin();
      }
      throw error;
    },
  },
};
